import axios,{ AxiosError,AxiosResponse } from "axios";
import { AuthBodyType } from "../types";
import type { HostModelType } from "../types/fluxo/types";
import { applyFirebaseTokenRetry } from './api';

class Hospedeiro {
  private api = applyFirebaseTokenRetry(axios.create({
    baseURL: `${process.env.REACT_APP_AXYMA_MICROSSERVICES_APIS_URL}/empresa`,
  }));

  getAllhospedeiroModelo = async (body: AuthBodyType) => {
    try {
      const data: AxiosResponse = await this.api.get("/hospedeiro-modelo/", { headers: { ...body } });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (axios.isAxiosError(error)) {
        console.error(error.message);
        throw new Error(error.message);
      }
    }
  };

  create = async (body: AuthBodyType, empresa: string, nome: string, idModelo: string, campos: HostModelType["campos"]) => {
    try {
      const data: AxiosResponse = await this.api.post(
        "/hospedeiro/",
        {
          empresa,
          nome,
          idModelo,
          campos,
        },
        { headers: { ...body } },
      );
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (axios.isAxiosError(error)) {
        console.error(error.message);
        throw new Error(error.message);
      }
    }
  };

  getAll = async (body: AuthBodyType, id: string) => {
    try {
      const data: AxiosResponse = await this.api.get(`/hospedeiro/?modelo=${id}`, { headers: { ...body } });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (axios.isAxiosError(error)) {
        console.error(error.message);
        throw new Error(error.message);
      }
    }
  };

  delete = async (body: AuthBodyType, id: string) => {
    try {
      const data: AxiosResponse = await this.api.delete(`/hospedeiro/${id}`, { headers: { ...body } });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (axios.isAxiosError(error)) {
        console.error(error.message);
        throw new Error(error.message);
      }
    }
  };

  update = async (body: AuthBodyType, id: string, empresa: string, nome: string, idModelo: string, campos: HostModelType["campos"]) => {
    try {
      const data: AxiosResponse = await this.api.put(
        `/hospedeiro/${id}`,
        {
          empresa,
          nome,
          idModelo,
          campos,
        },
        { headers: { ...body } },
      );
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (axios.isAxiosError(error)) {
        console.error(error.message);
        throw new Error(error.message);
      }
    }
  };

  getAllByFormId = async (body: AuthBodyType, form: string) => {
    try {
      const data: AxiosResponse = await this.api.get(`/unidades?form=${form}`, { headers: { ...body } });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (axios.isAxiosError(error)) {
        console.error(error.message);
        throw new Error(error.message);
      }
    }
  };
}

export default Hospedeiro;
